package org.example.zone360.models

import kotlinx.serialization.Serializable


@Serializable
data class RemoveUserSeasonData(
    val message: String? = null,
    val removedSeasonID: String? = null,
    val error: String? = null
)


@Serializable
data class RemoveUserSeasonPayload(
    val userID: String,
    val organization: String,
    val seasonID: String
)